module.exports = __webpack_public_path__ + "static/img/yundangpu.3aaaf4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/other/yundangpu.png
// module id = zZIN
// module chunks = 1